export const GET_POKA_CHECKLIST_START = 'GET_POKA_CHECKLIST_START';
export const GET_POKA_CHECKLIST_SUCCESS = 'GET_POKA_CHECKLIST_SUCCESS';
export const GET_POKA_CHECKLIST_FAIL = 'GET_POKA_CHECKLIST_FAIL';

export const START_POKA_CHECKLIST_START = 'START_POKA_CHECKLIST_START';
export const START_POKA_CHECKLIST_SUCCESS = 'START_POKA_CHECKLIST_SUCCESS';
export const START_POKA_CHECKLIST_FAIL = 'START_POKA_CHECKLIST_FAIL';

export const FINISH_POKA_CHECKLIST_START = 'FINISH_POKA_CHECKLIST_START';
export const FINISH_POKA_CHECKLIST_SUCCESS = 'FINISH_POKA_CHECKLIST_SUCCESS';
export const FINISH_POKA_CHECKLIST_FAIL = 'FINISH_POKA_CHECKLIST_FAIL';
